/**
 * zoneCheck.
 *
 * @param data
 * @returns boolean
 */
export function zoneCheck(
/** points */
data) {
    let { x, y } = data;
    if (x.length !== y.length) {
        return false;
    }
    return true;
}
//# sourceMappingURL=zoneCheck.js.map